<template>
	<div>
		<v-navigation-drawer v-model="drawer" color="brown darken-1" dark app class="menu">
			<v-list-item>
				<v-list-item-title class="title">
					CETABA
				</v-list-item-title>
			</v-list-item>

			<v-list >
				<v-list-item :to="{ name: 'Home' }">
					<v-list-item-action>
						<v-icon dense>fal fa-home-lg-alt</v-icon>
					</v-list-item-action>
					<v-list-item-title>Home</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'MeusCursos' }">
					<v-list-item-action>
						<v-icon dense>fal fa-chalkboard</v-icon>
					</v-list-item-action>
					<v-list-item-title>Meus cursos</v-list-item-title>
				</v-list-item>
				<v-list-item :to="{ name: 'MeusDados' }">
					<v-list-item-action>
						<v-icon dense>fal fa-user-edit</v-icon>
					</v-list-item-action>
					<v-list-item-title>Meus dados</v-list-item-title>
				</v-list-item>
				<v-list-item href="http://cetaba.org/" target="_blank">
					<v-list-item-action>
						<v-icon dense>fal fa-link</v-icon>
					</v-list-item-action>
					<v-list-item-title>Ir para o site</v-list-item-title>
				</v-list-item>

				<v-divider v-if="user.admin==1"></v-divider>
				<v-subheader v-if="user.admin==1">Admin</v-subheader>

				<v-list-item v-if="user.admin==1" :to="{ name: 'Cursos' }">
					<v-list-item-action>
						<v-icon dense>fal fa-chalkboard</v-icon>
					</v-list-item-action>
					<v-list-item-title>Cursos</v-list-item-title>
				</v-list-item>

				<v-list-item v-if="user.admin==1" :to="{ name: 'Users' }">
					<v-list-item-action>
						<v-icon dense>fal fa-users-class</v-icon>
					</v-list-item-action>
					<v-list-item-title>Usuários</v-list-item-title>
				</v-list-item>
			</v-list>

			

			<template v-slot:append>
				<div class="pa-2">
					<v-btn @click="logout" block color="success">
						<v-icon left>fal fa-sign-out-alt</v-icon>Sair
					</v-btn>
				</div>
			</template>
		</v-navigation-drawer>

		<v-app-bar app color="brown" dark dense class="menu" hide-on-scroll>
			<v-app-bar-nav-icon @click.stop="drawer = !drawer" title="Menu"></v-app-bar-nav-icon>
			<v-toolbar-title>Olá {{ user.nome }}</v-toolbar-title>
			<v-divider class="mx-4" vertical></v-divider>

			<v-spacer></v-spacer>

			<v-btn icon small color="white" @click="sheet = !sheet">
				<v-icon dark>fas fa-copyright</v-icon>
			</v-btn>

			<v-bottom-sheet v-model="sheet" dark>
				<v-sheet class="text-center pa-2">
					<div>
						<p>
							Copyright &copy; 2020 - {{ $date(Date()).format('YYYY') }}
							<br>
							Todos os direitos reservados a <a target="_blank" href="http://cetaba.org/">CETABA</a>
						</p>
						<h5 class="font-weight-regular pb-2">
							Todos os materiais vinculados no site são de propriedade da sua desenvolvedora CETABA (Centro tecnológico de alimentos, bebidas e meio ambiente) e seu representante legal DERMÂNIO TADEU LIMA FERREIRA.<br>
							A cópia sem a devida, formal e expressa autorização sujeita o autor da ação a processo judicial.<br>
							Para copiar ou usar os materiais o interessado deverá entrar em contato pelos canais informados no site. <br>
							Todos os direitos reservados.
						</h5>
						<v-divider></v-divider>
						<p class="mt-2">Entre em contato</p>
						<p>
							E-mail: tadeu_10@hotmail.com
							<br>
							Telefone: +55 (45) 99947-1274
						</p>
						<p>
							Developed by
							<a target="_blank" href="https://bellon.app/"
								>Web Bellon</a
							>
						</p>
					</div>
				</v-sheet>
			</v-bottom-sheet>

		</v-app-bar>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import idb from '@/api/idb'

export default {
	data() {
		return {
			drawer: null,
			collapseOnScroll: true,
			sheet: false,
		}
	},
	computed: {
		...mapState([
			'user',
			'XMLHttpRequest',
		]),
	},
	methods: {
		historyBack() {
			this.$router.go(-1)
		},
		logout() {
			let formData = new FormData()
			formData.append('user_id', this.user.id)
			formData.append('token', this.user.token)
			let vd = this
			this.$axiosPost.post('logout.php', formData)
			.then(function(response){
				if(response.data['error']===0){
					idb.clearObject(['user'])
					vd.$store.dispatch('logOut', { destination: 'Home' })
				}else{
					vd.$store.dispatch('alert', {
						alertMessage: response.data['alertMessage'],
						alertType: response.data['alertType'],
					})
				}
			})
			.catch(function(response){
				vd.$store.dispatch('XMLHttpRequest', { value: false })
				console.log('ERROR!! '+response)
			})
		},
	},
}
</script>

<style lang="css">
	.v-toolbar__title{
		padding-left: 10px !important;
	}
</style>